module.exports = __webpack_public_path__ + "img/stacy.7408b02c.jpg";